import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowLineageCountsFragmentGql } from './FlowLineageCountsFragmentGql';

export const FlowLineageCountsQueryGql: DocumentNode = gql`
query FlowLineageCountsQuery($flowVizportalUrlId: String!, $publishedConnectionsLineageEnabled: Boolean!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    ...FlowLineageCountsFragment
  }
}
${FlowLineageCountsFragmentGql}
`;
